<!-- 范围数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
            :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index == 0">
                <!-- 主要信息 -->
                <el-form ref="sendDataInfo" :model="sendDataInfo" inline size="mini" :show-message="false" label-width="150px"
                  :rules="rules">
                  <el-form-item label="编号分类" prop="codeClassify">
                    <label slot="label" :style="$common.labelStyle('编号分类')" v-html="$common.htmlLabel('编号分类')"></label>
                    <el-select class="form_codition" v-model.trim="sendDataInfo.codeClassify" filterable placeholder="请选择" clearable>
                      <el-option v-for="(item, keys) in cataList" :key="keys" :label="item.dtName" :value="item.codeClassify">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="编号名称" prop="codeType">
                    <label slot="label" :style="$common.labelStyle('编号名称')" v-html="$common.htmlLabel('编号名称')"></label>
                    <el-input class="form_codition" v-model.trim="sendDataInfo.codeType" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="前缀" prop="prefix">
                    <label slot="label" :style="$common.labelStyle('前缀')" v-html="$common.htmlLabel('前缀')"></label>
                    <el-input class="form_codition" v-model.trim="sendDataInfo.prefix" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="数字长度" prop="serialnum">
                    <label slot="label" :style="$common.labelStyle('数字长度')" v-html="$common.htmlLabel('数字长度')"></label>
                    <el-input class="form_codition" type="number" v-model.trim="sendDataInfo.serialnum" clearable></el-input>
                  </el-form-item>
               
                  
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div style="text-align:center; margin-top:20px;">
          <el-button v-if="dataActionBox.actionType != 2" type="primary"
            @click="$emit('drawerCancel')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')"
            v-if="dataActionBox.actionType == 1">保存</el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
  name: "codSettingListAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    var _this = this
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
				codeType: '',
				prefix: '',
				serialnum: 6,
				codeClassify: 0,
			},
      rules: {
				codeType: [
					{ required: true, message: '请输入编号名称', trigger: 'submit' },
				],
				prefix: [
					{ required: true, message: '请输入前缀', trigger: 'submit' }
				],
				serialnum: [
					{ required: true, message: '请输入数字长度', trigger: 'submit' }
				],
				codeClassify: [
					{  required: true, message: '请选择编号分类', trigger: 'submit' }
				],
			},
      tabForm: [],
      showTabs: "",
      DialogVisible: false, //检索
      seId: "",
      seWidth: "",
      seTitle: "",
      seType: "",
      isLoaded: false,
      cataList:[{
				dtName: '商品',
				codeClassify: 0
			}, {
				dtName: '供应商',
				codeClassify: 1
			}, {
				dtName: '客户',
				codeClassify: 2
			}],
      scopeList: [
        {
          value: 0,
          label: "生产范围",
        },
        {
          value: 1,
          label: "经营范围",
        },
        {
          value: 2,
          label: "诊疗范围",
        },
      ], //范围类型列表
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.scopeName": {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.scopeCode =this.$common.createPinyinCode(newValue,this.sendDataInfo.scopeCode);
      },
      deep: true,
    },
  },
  //方法集合
  methods: {

    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      this.seId = sId;
      this.seType = type;
      this.DialogVisible = true;
    },
    //提取返回
    changeInputModel(val) {
      // console.log(val)
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          // console.log('sendDataInfo', this.sendDataInfo)
          this.sub();
        } else {
          this.$message({
            message: "请完善必填信息",
            type: "error",
          });
          return false;
        }
      });
    },
    async sub() {
      var responseData;
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.addQueryCodeSetting(this.sendDataInfo);
      } else if (this.dataActionBox.actionType == 1) {
        responseData = await this.$http.updateQueryCodeSetting(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
        // this.dataActionBox.showStatus = false
        // this.$parent.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消
    initActionBox(formName1) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel");
          // this.$parent.getDataList()
          this.init();
          this.$refs[formName1].resetFields();
        })
        .catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "serialnum" ) {
          this.sendDataInfo[key] = 6;
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    //父级传入
    openBox(cate, formData, oldData = "") {
      this.showTabs = this.dataActionBox.boxTitle +'编号规则'
      this.init();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增";
        this.dataActionBox.openMode = "ltr";
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = "编辑";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      } else {
        this.dataActionBox.boxTitle = "查看";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      }
      this.filterMainField()
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
    },
    // 过滤表单不同类型
    filterMainField() {
      this.tabForm = [
        {
          jciName: this.dataActionBox.boxTitle ,
          jurconfigform: []
        }
      ]
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData;
      this.openBox(params.cate, params.formData, params.oldData[0]);
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
